module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<footer class="J_footer footer">\r\n    <section class="btn-list">\r\n        {{telUl}}\r\n    </section>\r\n    <button class="confirm-btn">确定签署</button>\r\n</footer>';

}
return __p
}